import a from "../../temp-lib/config/index.js";
import { SsoProviderType as l } from "../../temp-lib/constants/account.js";
var e = /* @__PURE__ */ ((t) => (t.JumpToConsent = "jump_to_consent", t.OAuthClientId = "client_id", t.OAuthCode = "code", t.OAuthResponseType = "response_type", t.OAuthScope = "scope", t.OAuthState = "state", t.SsoHandleUrl = "sso_handle_uri", t.SsoQueryString = "sso_query_string", t.SsoRedirectUrl = "redirect_uri", t.GameName = "game_name", t.EnableWalletLogin = "enable_wallet_login", t.Locale = "locale", t.Reload = "reload", t.Platform = "platform", t.DeepLinkScheme = "deep_link_scheme", t))(e || {});
const h = {
  AccessToken: `access_token_${a.VARIABLES.ENV}`,
  Logout: `logout_${a.VARIABLES.ENV}`,
  ChainType: "chain_type",
  LoginType: "login_type",
  WalletType: "sso_wallet_type"
};
var _ = /* @__PURE__ */ ((t) => (t.SsoQuery = "sso_query", t))(_ || {}), c = ((t) => (t[t.Apple = l.APPLE] = "Apple", t[t.Discord = l.DISCORD] = "Discord", t[t.Google = l.GOOGLE] = "Google", t[t.Skymavis = l.SKY_MAVIS] = "Skymavis", t[t.Twitter = l.TWITTER] = "Twitter", t[t.Unspecified = l.Unspecified] = "Unspecified", t.Email = "email", t.Ronin = "ronin", t))(c || {}), m = /* @__PURE__ */ ((t) => (t.SsoLogin = "sso_login", t))(m || {});
export {
  h as ApeironSsoCookieKey,
  m as ApeironSsoEvent,
  _ as ApeironSsoLocalKey,
  c as ApeironSsoLoginType,
  e as ApeironSsoQuery
};
//# sourceMappingURL=apeironSso.js.map
